import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation DeleteReleaseMutation($input: DeleteReleaseInput!) {
    deleteRelease(input: $input) {
      isDeleted
    }
  }
`;

const DeleteReleaseMutation = (id, callback) => {
  const config = {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.deleteRelease);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default DeleteReleaseMutation;
